import React from 'react';
import { ClipboardCheckIcon, ClockIcon, ListOrderedIcon, UsersIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { benefits } from '../../data/content';
const icons = [ClockIcon, ListOrderedIcon, UsersIcon, ClipboardCheckIcon];
export function BenefitsSection() {
  return <section aria-labelledby="benefits-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-67" data-mp="1ycnpz5l4cziq">
      <div className="mx-auto max-w-6xl" data-id="element-68" data-mp="1tfe2vwl7czy2">
        <SectionHeading id="benefits-heading" title={<>
              Meno preparazione. <Accent data-id="element-70" data-mp="1jojf2nsb5sai">Più spazio per insegnare.</Accent>
            </>} data-id="element-69" data-mp="1tgfga7poxyiy" />

        <ul className="mt-12 grid gap-y-10 border-t border-brand-charcoal/10 pt-10 sm:grid-cols-2 sm:gap-x-10 lg:grid-cols-4" role="list" data-id="element-71" data-mp="1epq0es1abv8r">
          {benefits.map((benefit, index) => {
          const Icon = icons[index];
          return <li key={benefit.title} className="text-center sm:text-left" data-id="element-72" data-mp="15qco7rls0skc" data-mpi={index}>
                <Icon className="mx-auto h-6 w-6 text-brand-rosewood sm:mx-0" strokeWidth={1.5} aria-hidden="true" data-id="element-73" data-mp="2itrr4o2axbsn" />
                <h3 className="mt-4 font-display text-[1.45rem] font-bold leading-tight text-brand-charcoal" data-id="element-74" data-mp="2nm1j09mz8lxk">
                  {benefit.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/65 sm:text-[15px]" data-id="element-75" data-mp="2dux6rhoorf6f">{benefit.text}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}